import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

type Props = {
  ariaLabel: string;
  disabled?: boolean;
  onClick: () => void;
};

const StepNavigateShortcutButton = ({ ariaLabel, disabled = false, onClick }: Props) => {
  return (
    <Tooltip title={ariaLabel}>
      <span>
        <IconButton
          size="small"
          aria-label={ariaLabel}
          disabled={disabled}
          onClick={onClick}
          sx={{
            border: "1px solid",
            borderColor: "grey.400",
            borderRadius: 1,
            width: 36,
            height: 36,
          }}
        >
          <MoreHorizIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default StepNavigateShortcutButton;
